import * as angular from 'angular';

class ProgressbarComponentCtrl implements ng.IController {
    public progressNumber: number = 0;
    public maxProgressNumber: number;
    public abort: boolean;
    public delay: number;
    public title: string;
    public leftDescription: string;
    public middleDescription: string;
    public rightDescription: string;

    private timeRemain: number;

    constructor(private $timeout: ng.ITimeoutService) {}

    $onInit() {
        this.timeRemain = this.maxProgressNumber * this.delay;
        this.$timeout(() => {
            this.checkResponseFake();
        }, this.delay);
    }

    private checkResponseFake() {
        let nextSlot = this.calculateNextWaitTime();
        this.progressNumber = this.progressNumber + 1;
        if (this.progressNumber <= this.maxProgressNumber && !this.abort) {
            this.$timeout(() => {
                this.checkResponseFake();
            }, nextSlot);
        } else if (this.abort) {
            this.progressNumber = this.maxProgressNumber;
        }
    }

    private calculateNextWaitTime(): number {
        let nextSlot = this.timeRemain;
        if (this.progressNumber < this.maxProgressNumber) {
            nextSlot = Math.random() * 160 + 120;
            this.timeRemain -= nextSlot;
        }
        return nextSlot;
    }
}

angular.module('app').component('pkpProgressbar', {
    controller: ProgressbarComponentCtrl,
    template: require('app/_directives/progressbar.component.html'),
    bindings: {
        abort: '<',
        delay: '<',
        maxProgressNumber: '<',
        title: '@',
        leftDescription: '@',
        middleDescription: '@',
        rightDescription: '@'
    }
});
